import { NgModule } from '@angular/core';
import { ShownForRolesDirective } from './directives/shown-for-roles.directive';

@NgModule({
    declarations: [ShownForRolesDirective],
    imports: [],
    exports: [ShownForRolesDirective]
})
export class LibAuthModule {
}
